import { Loan, OnboardingDetailsRole } from '@nemuru-eng/js-api-client';

export const findCurrentParticipantOnboardingDetailsByOnboardingDetailsId = ({
  loan,
  onboardingDetailsId,
}: {
  loan?: Loan | null;
  onboardingDetailsId?: string;
}) => loan?.onboardingDetails.find((e) => e.id === onboardingDetailsId);

export const findCurrentParticipantIdByRole = ({
  loan,
  participantRole,
}: {
  loan: Loan;
  participantRole: OnboardingDetailsRole;
}) => {
  switch (participantRole) {
    case OnboardingDetailsRole.BORROWER:
      return loan.borrowerId;
    case OnboardingDetailsRole.CO_BORROWER:
      return loan.coBorrowerId;
    case OnboardingDetailsRole.GUARANTOR:
      return loan.guarantorIds?.[0];
    default:
      return null;
  }
};
